import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Space } from 'antd';
import { Currency } from '@common/components';
import ExtensionDetailItemStateStyledValue from './extension-detail-item-state-styled-value';

const { Text } = Typography;

export default function ExtensionDetailItemRate({
  value,
  state = '',
  overrided = false,
}) {
  const currencyValue = <Currency value={value} />;

  return (
    <Space>
      {overrided ? (
        <Text type="secondary" strong delete>
          {currencyValue}
        </Text>
      ) : (
        <ExtensionDetailItemStateStyledValue
          state={state}
          value={currencyValue}
        />
      )}
    </Space>
  );
}

ExtensionDetailItemRate.propTypes = {
  value: PropTypes.number.isRequired,
  state: PropTypes.string,
  overrided: PropTypes.bool,
};
